<!--Title-->
<h3>{{ "_General_Lobby_Activity_Text_" | translate }}</h3>

<div class="cc-content-wrapper lobby-activity-wrapper">
  <div class="cc-single-tab">
    <div class="k-overlay" *ngIf="FiltersPopupOpened"></div>
    <div kendoWindowContainer></div>
    <!--Header-->
    <form
      class="form-horizontal"
      [formGroup]="detailViewForm"
      (ngSubmit)="doNothing()"
    >
      <div
        class="row cc-action-panel"
        [hidden]="initialReportExecutionComplete == false"
      >
        <div class="cc-filters align-items-end">
          <div
            class="me-3 view-selector-dropdown"
            *ngIf="initialReportExecutionComplete == true"
          >
            <label>{{ "_General_View_Text_" | translate }}</label>
            <select
              #viewList
              id="viewList"
              class="cc-select-dropdown filter-list form-control"
              placeholder="'_General_Report_SelectView_Text_' | translate"
              formControlName="selectedViewDropdown"
              (change)="selectedViewChanged(viewList.value)"
            >
              <ng-container
                *ngFor="let value of commonData.options.defaultViews"
              >
                <option
                  *ngIf="value.viewId !== 6 || hasViewSignInOutReportPermission"
                  [value]="value.viewName"
                >
                  {{
                    value.viewLocalizedName
                      ? (value.viewLocalizedName | translate)
                      : value.viewLocalizedName
                  }}
                </option>
              </ng-container>
            </select>
          </div>

          <div class="me-3">
            <label>{{ "_Report_Filter_Template_Text_" | translate }}</label>
            <select
              #filterList
              id="filterList"
              class="cc-select-dropdown filter-list limited-width form-control"
              placeholder="'_General_Select_Text_' | translate"
              formControlName="activeFilterTemplate"
              (change)="activeTemplateChanged(filterList.value)"
            >
              <option
                *ngFor="let value of commonData.templates"
                [ngValue]="value.templateName"
              >
                {{
                  value.templateName == "None"
                    ? ("_Report_Filter_None_Ts_Text_" | translate)
                    : value.templateName
                }}
              </option>
            </select>
          </div>

          <div class="me-3">
            <button class="btn btn-secondary" (click)="goToFilterOptions()">
              {{ "_General_FilterOption_Text_" | translate }}
            </button>
          </div>
        </div>

        <div class="cc-filters ms-3 d-flex align-items-end">
          <div class="me-3 ms-3 d-flex align-items-center">
            <div class="me-2">
              <label>{{ "_General_From_Text_" | translate }}</label>
              <kendo-datepicker
                class="date-picker"
                id="from"
                formControlName="from"
                [disabledDates]="isDateDisabled.bind(this)"
                [readOnlyInput]="true"
                [navigation]="false"
                calendarType="infinite"
                (valueChange)="fromDateChange()"
                format="M/d/yyyy"
              >
                <kendo-datepicker-messages
                  today="{{ '_General_Today_Text_' | translate }}"
                  toggle="{{ '_General_Toggle_Calendar_Text_' | translate }}"
                  parentViewButtonTitle="{{
                    '_General_Navigate_To_Parent_View_Text_' | translate
                  }}"
                >
                </kendo-datepicker-messages>
              </kendo-datepicker>
            </div>
            <div>
              <label>{{ "_General_To_Text_" | translate }}</label>
              <kendo-datepicker
                class="date-picker"
                id="to"
                formControlName="to"
                [disabledDates]="isDateDisabled.bind(this)"
                [readOnlyInput]="true"
                [navigation]="false"
                calendarType="infinite"
                (valueChange)="toDateChange()"
                format="M/d/yyyy"
              >
                <kendo-datepicker-messages
                  today="{{ '_General_Today_Text_' | translate }}"
                  toggle="{{ '_General_Toggle_Calendar_Text_' | translate }}"
                  parentViewButtonTitle="{{
                    '_General_Navigate_To_Parent_View_Text_' | translate
                  }}"
                >
                </kendo-datepicker-messages>
              </kendo-datepicker>
            </div>
          </div>

          <button
            class="btn btn-primary"
            (click)="runReportDirect()"
            [disabled]="isReportRunning"
          >
            {{ "_Report_Lobby_Run_Report_Text_" | translate }}
          </button>
        </div>
      </div>

      <div
        class="d-flex view-selector align-items-end justify-content-center"
        *ngIf="
          pageInitialized == true &&
          commonData.options &&
          commonData.options.defaultViews
        "
      >
        <!-- <div class="last-refreshed-wrapper" *ngIf="loading == 0 && lastRefreshed">
          <label id="lastRefreshed" class="lastRefreshedMessage"><span>{{lastRefreshed}} {{ lastUpdate | utcOffsetConversion : lastUpdate.getTimezoneOffset() +
            preferedTzOffset |
            date: "longDate" }} </span><span>{{ lastUpdate | utcOffsetConversion :
            lastUpdate.getTimezoneOffset() + preferedTzOffset | date: "h:mm:ss a" }}({{ preferedTzCode }})</span></label>
        </div> -->
        <div *ngIf="loading == 0"></div>
        <div
          *ngIf="loading > 0 && initialReportExecutionComplete == true"
        ></div>
        <div *ngIf="loading > 0 && initialReportExecutionComplete == true">
          <label
            id="loadingPrompt"
            class="loading-prompt"
            *ngIf="loading > 0"
            >{{ loadingPrompt }}</label
          >
        </div>
        <div
          class="initial-loading-prompt col-md-12"
          *ngIf="loading > 0 && initialReportExecutionComplete == false"
        >
          <label
            id="loadingPrompt"
            class="loading-prompt"
            *ngIf="loading > 0"
            >{{ loadingPrompt }}</label
          >
        </div>
      </div>

      <!--Summary Info-->
      <div
        class="col-md-12 summary-info-container"
        *ngIf="
          pageInitialized == true && initialReportExecutionComplete == true
        "
      >
        <div class="summary-data">
          <label>{{ "_Report_Lobby_Total_Records_Text_" | translate }}</label>
          <div class="summary-data-value">
            {{
              commonData.lobbyReportHeaderData.totalRecords
                ? (commonData.lobbyReportHeaderData.totalRecords | number)
                : 0
            }}
          </div>
        </div>
        <div class="summary-data" *ngIf="isACLicenseEnabled$ | async">
          <label>{{ "_General_No_Show_Text_" | translate }}</label>
          <div class="summary-data-value">
            {{
              commonData.lobbyReportHeaderData.noShows
                ? (commonData.lobbyReportHeaderData.noShows | number)
                : 0
            }}
          </div>
        </div>
        <div class="summary-data" *ngIf="isACLicenseEnabled$ | async">
          <label>{{
            "_Report_Lobby_Appointments_Completed_Text_" | translate
          }}</label>
          <div class="summary-data-value">
            {{
              commonData.lobbyReportHeaderData.appointmentsCompleted
                ? (commonData.lobbyReportHeaderData.appointmentsCompleted
                  | number)
                : 0
            }}
          </div>
        </div>
        <div class="summary-data">
          <label>{{
            "_Report_Lobby_WalkIns_Completed_Text_" | translate
          }}</label>
          <div class="summary-data-value">
            {{
              commonData.lobbyReportHeaderData.walkinsCompleted
                ? (commonData.lobbyReportHeaderData.walkinsCompleted | number)
                : 0
            }}
          </div>
        </div>
        <div class="summary-data">
          <label>{{ "_General_LWA_Text_" | translate }}</label>
          <div class="summary-data-value">
            {{
              commonData.lobbyReportHeaderData.abandons
                ? (commonData.lobbyReportHeaderData.abandons | number)
                : 0
            }}
          </div>
        </div>
        <div class="summary-data">
          <label>{{ "_General_LWA_Text_" | translate }} %</label>
          <div class="summary-data-value">
            {{
              commonData.lobbyReportHeaderData.abandonsAsPercentOfTotalRecords
                ? commonData.lobbyReportHeaderData
                    .abandonsAsPercentOfTotalRecords
                : 0
            }}
          </div>
        </div>
        <div class="summary-data">
          <label>{{ "_General_Average_Wait_Time_Text_" | translate }}</label>
          <div class="summary-data-value">
            {{ commonData.lobbyReportHeaderData.avgWaitTimeFormatted }}
          </div>
        </div>
        <div class="summary-data">
          <label>{{ "_General_Average_Assist_Time_Text_" | translate }}</label>
          <div class="summary-data-value">
            {{ commonData.lobbyReportHeaderData.avgAssistTimeFormatted }}
          </div>
        </div>
      </div>
    </form>

    <!-- <div *ngIf="loading > 0" class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span></span>
      </div>
    </div> -->

    <div class="row report-charts" *ngIf="!isLocationDataAvailable">
      <div
        class="col-md-12 d-flex view-selector align-items-end justify-content-center"
      >
        <span class="chart-empty">No data available.</span>
      </div>
    </div>

    <!-- Location Comparison View Charts -->
    <div
      class="row report-charts"
      *ngIf="
        pageInitialized == true &&
        getCurrentViewName() === 'Location Comparison'
      "
    >
      <div
        class="col-md-12"
        *ngIf="commonData.trafficAndWaitByLocationVisible == true"
      >
        <kendo-chart
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{
              '_Report_Lobby_WaitTime_by_Location_Time_Text_' | translate
            }}"
          ></kendo-chart-title>
          <kendo-chart-legend position="bottom">
            <kendo-chart-legend-item
              [visual]="legendVisuals"
            ></kendo-chart-legend-item>
          </kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="let item of commonData.trafficAndWaitByLocationValueAxis"
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
              [labels]="item.labels ?? {}"
            >
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [min]="commonData.firstCategoryIndex"
              [max]="commonData.lastCategoryIndex"
              [categories]="commonData.trafficAndWaitByLocationCategories"
              [axisCrossingValue]="
                commonData.trafficAndWaitByLocationCrossingValues
              "
              [labels]="categoryLabelMultiline"
            >
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              *ngIf="isACLicenseEnabled$ | async"
              [data]="commonData.trafficAndWaitByLocationSeriesData[0].data"
              [name]="commonData.trafficAndWaitByLocationSeriesData[0].name"
              [color]="commonData.trafficAndWaitByLocationSeriesData[0].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_General_Appointments_Text_' | translate }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.trafficAndWaitByLocationSeriesData[1].data"
              [name]="commonData.trafficAndWaitByLocationSeriesData[1].name"
              [color]="commonData.trafficAndWaitByLocationSeriesData[1].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_Report_WalkIns_Ts_Text_' | translate }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.trafficAndWaitByLocationSeriesData[2].data"
              [name]="commonData.trafficAndWaitByLocationSeriesData[2].name"
              [color]="commonData.trafficAndWaitByLocationSeriesData[2].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_General_LWA_Text_' | translate }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.trafficAndWaitByLocationSeriesData[3].data"
              [name]="commonData.trafficAndWaitByLocationSeriesData[3].name"
              [color]="commonData.trafficAndWaitByLocationSeriesData[3].color"
              [type]="commonData.trafficAndWaitByLocationSeriesData[3].type"
              [axis]="commonData.trafficAndWaitByLocationSeriesData[3].axis"
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_General_Report_Wait_Time_Text_" | translate }}:
                    {{ dataItem.ValMinutes }}:{{ dataItem.ValSeconds }}
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
      <div
        class="col-md-12"
        *ngIf="commonData.productsAndServicesByLocationVisible == true"
      >
        <kendo-chart
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{
              '_Report_Lobby_PS_Provided_by_Location_Text_' | translate
            }}"
          ></kendo-chart-title>
            <kendo-chart-series-item
              *ngIf="commonData.avgTrafficWaitByDaySeriesData.length > 4"
              [data]="commonData.avgTrafficWaitByDaySeriesData[4].data"
              [name]="commonData.avgTrafficWaitByDaySeriesData[4].name"
              [color]="commonData.avgTrafficWaitByDaySeriesData[4].color"
              [type]="commonData.avgTrafficWaitByDaySeriesData[4].type"
              [axis]="commonData.avgTrafficWaitByDaySeriesData[4].axis"
              [stack]="commonData.avgTrafficWaitByDaySeriesData[4].stack"
              [visibleInLegend]="false"
            >
              <kendo-chart-series-item-labels
                [visible]="true"
                position="outsideEnd"
                [content]="setTotal"
                [visual]="setTotalVisual"
              ></kendo-chart-series-item-labels>
            </kendo-chart-series-item>
          <kendo-chart-legend position="bottom"
            ><kendo-chart-legend-item
              [visual]="legendVisuals"
            ></kendo-chart-legend-item>
          </kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="
                let item of commonData.productsAndServicesByLocationValueAxis
              "
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
            >
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [min]="commonData.firstCategoryIndex"
              [max]="commonData.lastCategoryIndex"
              [categories]="commonData.productsAndServicesByLocationCategories"
              [labels]="categoryLabelMultiline"
            >
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              [data]="
                commonData.productsAndServicesByLocationSeriesData[0].data
              "
              [name]="
                commonData.productsAndServicesByLocationSeriesData[0].name
              "
              [color]="
                commonData.productsAndServicesByLocationSeriesData[0].color
              "
            >
              <kendo-chart-series-item-tooltip
                format="{{
                  '_Report_Lobby_Products_Text_' | translate
                }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="
                commonData.productsAndServicesByLocationSeriesData[1].data
              "
              [name]="
                commonData.productsAndServicesByLocationSeriesData[1].name
              "
              [color]="
                commonData.productsAndServicesByLocationSeriesData[1].color
              "
            >
              <kendo-chart-series-item-tooltip
                format="{{
                  '_Report_Lobby_Services_Text_' | translate
                }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="
                commonData.productsAndServicesByLocationSeriesData[2].data
              "
              [name]="
                commonData.productsAndServicesByLocationSeriesData[2].name
              "
              [color]="
                commonData.productsAndServicesByLocationSeriesData[2].color
              "
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_Report_Filters_Other_Text_' | translate }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
      <div
        class="col-md-12"
        *ngIf="commonData.avgAssistTimeByLocationVisible == true"
      >
        <kendo-chart
          (seriesHover)="seriesHover($event)"
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{
              '_Report_Lobby_AssistTime_by_Location_Text_' | translate
            }}"
          ></kendo-chart-title>
          <kendo-chart-legend position="bottom">
            <kendo-chart-legend-item
              [visual]="legendVisuals_AssistTime"
            ></kendo-chart-legend-item>
          </kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="let item of commonData.avgAssistTimeByLocationValueAxis"
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
            >
            </kendo-chart-value-axis-item>
            <!-- <kendo-chart-value-axis-item-labels [visual]="yaxisVisual">
          </kendo-chart-value-axis-item-labels> -->
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [min]="commonData.firstCategoryIndex"
              [max]="commonData.lastCategoryIndex"
              [categories]="commonData.avgAssistTimeByLocationCategories"
              [labels]="categoryLabelMultiline"
            >
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              *ngFor="let item of commonData.mappedLocationsAssistSeries"
              [data]="item.items"
              field="avgAssistTime"
              [name]="item.value"
              type="column"
              [visual]="seriesVisuals"
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_General_Average_Assist_Time_Text_" | translate }}:
                    {{ dataItem.ValMinutes }}:{{ dataItem.ValSeconds }}
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>

            <!-- [markers]="{visual: visual}"  -->
            <kendo-chart-series-item
              *ngFor="let item of commonData.mappedLocationsAssistSeries"
              [data]="item.items"
              field="StdMinutes"
              type="line"
              [width]="1"
              [highlight]="{ visible: false }"
              [color]="getSeriesColorBasedOnProductServiceType(item.items[0])"
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_General_Time_Standard_Text_" | translate }}:
                    {{ dataItem.StdMinutes }}:00
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
    </div>
    <!-- Traffic and Wait Time View Charts -->
    <div
      class="row report-charts"
      *ngIf="
        pageInitialized == true &&
        getCurrentViewName() === 'Traffic & Wait Time'
      "
    >
      <div
        class="col-md-6"
        *ngIf="commonData.avgTrafficWaitByHourVisible == true"
      >
        <!-- Traffic & Wait Time -->
        <kendo-chart
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{
              '_Report_Lobby_Traffic_and_WaitTime_Day_Text_' | translate
            }}"
          ></kendo-chart-title>
          <kendo-chart-legend position="bottom">
            <kendo-chart-legend-item
              [visual]="legendVisuals"
            ></kendo-chart-legend-item
          ></kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="let item of commonData.avgTrafficWaitByHourValueAxis"
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
              [labels]="item.labels ?? {}"
            >
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [categories]="commonData.avgTrafficWaitByHourCategories"
              [axisCrossingValue]="
                commonData.avgTrafficWaitByHourCrossingValues
              "
            >
              <kendo-chart-category-axis-item-labels [rotation]="-45">
              </kendo-chart-category-axis-item-labels>
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              *ngIf="isACLicenseEnabled$ | async"
              [data]="commonData.avgTrafficWaitByHourSeriesData[0].data"
              [name]="commonData.avgTrafficWaitByHourSeriesData[0].name"
              [color]="commonData.avgTrafficWaitByHourSeriesData[0].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_General_Appointments_Text_' | translate }}: {0:N1}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByHourSeriesData[1].data"
              [name]="commonData.avgTrafficWaitByHourSeriesData[1].name"
              [color]="commonData.avgTrafficWaitByHourSeriesData[1].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_Report_WalkIns_Ts_Text_' | translate }}: {0:N1}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByHourSeriesData[2].data"
              [name]="commonData.avgTrafficWaitByHourSeriesData[2].name"
              [color]="commonData.avgTrafficWaitByHourSeriesData[2].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_General_LWA_Text_' | translate }}: {0:N1}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByHourSeriesData[3].data"
              [name]="commonData.avgTrafficWaitByHourSeriesData[3].name"
              [color]="commonData.avgTrafficWaitByHourSeriesData[3].color"
              [type]="commonData.avgTrafficWaitByHourSeriesData[3].type"
              [axis]="commonData.avgTrafficWaitByHourSeriesData[3].axis"
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_General_Report_Wait_Time_Text_" | translate }}:
                    {{ dataItem.ValMinutes }}:{{ dataItem.ValSeconds }}
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
      <div
        class="col-md-6"
        *ngIf="commonData.avgTrafficWaitByMonthVisible == true"
      >
        <kendo-chart
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{
              '_Report_Lobby_Traffic_and_WaitTime_Month_Text_' | translate
            }}"
          ></kendo-chart-title>
          <kendo-chart-legend position="bottom">
            <kendo-chart-legend-item
              [visual]="legendVisuals"
            ></kendo-chart-legend-item>
          </kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="let item of commonData.avgTrafficWaitByMonthValueAxis"
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
              [labels]="item.labels ?? {}"
            >
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [categories]="commonData.avgTrafficWaitByMonthCategories"
              [axisCrossingValue]="
                commonData.avgTrafficWaitByMonthCrossingValues
              "
            >
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              *ngIf="isACLicenseEnabled$ | async"
              [data]="commonData.avgTrafficWaitByMonthSeriesData[0].data"
              [name]="commonData.avgTrafficWaitByMonthSeriesData[0].name"
              [color]="commonData.avgTrafficWaitByMonthSeriesData[0].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_General_Appointments_Text_' | translate }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByMonthSeriesData[1].data"
              [name]="commonData.avgTrafficWaitByMonthSeriesData[1].name"
              [color]="commonData.avgTrafficWaitByMonthSeriesData[1].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_Report_WalkIns_Ts_Text_' | translate }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByMonthSeriesData[2].data"
              [name]="commonData.avgTrafficWaitByMonthSeriesData[2].name"
              [color]="commonData.avgTrafficWaitByMonthSeriesData[2].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_General_LWA_Text_' | translate }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByMonthSeriesData[3].data"
              [name]="commonData.avgTrafficWaitByMonthSeriesData[3].name"
              [color]="commonData.avgTrafficWaitByMonthSeriesData[3].color"
              [type]="commonData.avgTrafficWaitByMonthSeriesData[3].type"
              [axis]="commonData.avgTrafficWaitByMonthSeriesData[3].axis"
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_General_Report_Wait_Time_Text_" | translate }}:
                    {{ dataItem.ValMinutes }}:{{ dataItem.ValSeconds }}
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
      <div
        class="col-md-6"
        *ngIf="commonData.avgTrafficWaitByDayVisible == true"
      >
        <kendo-chart
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{
              '_Report_Lobby_Traffic_and_WaitTime_Week_Text_' | translate
            }}"
          ></kendo-chart-title>
          <kendo-chart-legend position="bottom">
            <kendo-chart-legend-item
              [visual]="legendVisuals"
            ></kendo-chart-legend-item>
          </kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="let item of commonData.avgTrafficWaitByDayValueAxis"
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
              [labels]="item.labels ?? {}"
            >
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [categories]="commonData.avgTrafficWaitByDayCategories"
              [axisCrossingValue]="commonData.avgTrafficWaitByDayCrossingValues"
            >
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              *ngIf="isACLicenseEnabled$ | async"
              [data]="commonData.avgTrafficWaitByDaySeriesData[0].data"
              [name]="commonData.avgTrafficWaitByDaySeriesData[0].name"
              [color]="commonData.avgTrafficWaitByDaySeriesData[0].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_General_Appointments_Text_' | translate }}: {0:N1}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByDaySeriesData[1].data"
              [name]="commonData.avgTrafficWaitByDaySeriesData[1].name"
              [color]="commonData.avgTrafficWaitByDaySeriesData[1].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_Report_WalkIns_Ts_Text_' | translate }}: {0:N1}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByDaySeriesData[2].data"
              [name]="commonData.avgTrafficWaitByDaySeriesData[2].name"
              [color]="commonData.avgTrafficWaitByDaySeriesData[2].color"
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_General_LWA_Text_' | translate }}: {0:N1}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByDaySeriesData[3].data"
              [name]="commonData.avgTrafficWaitByDaySeriesData[3].name"
              [color]="commonData.avgTrafficWaitByDaySeriesData[3].color"
              [type]="commonData.avgTrafficWaitByDaySeriesData[3].type"
              [axis]="commonData.avgTrafficWaitByDaySeriesData[3].axis"
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_General_Report_Wait_Time_Text_" | translate }}:
                    {{ dataItem.ValMinutes }}:{{ dataItem.ValSeconds }}
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              *ngIf="commonData.avgTrafficWaitByDaySeriesData.length > 4"
              [data]="commonData.avgTrafficWaitByDaySeriesData[4].data"
              [name]="commonData.avgTrafficWaitByDaySeriesData[4].name"
              [color]="commonData.avgTrafficWaitByDaySeriesData[4].color"
              [type]="commonData.avgTrafficWaitByDaySeriesData[4].type"
              [axis]="commonData.avgTrafficWaitByDaySeriesData[4].axis"
              [stack]="commonData.avgTrafficWaitByDaySeriesData[4].stack"
              [visibleInLegend]="false"
            >
              <kendo-chart-series-item-labels
                [visible]="true"
                position="outsideEnd"
                [content]="setTotal"
                [visual]="setTotalVisual"
              ></kendo-chart-series-item-labels>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
      <div
        class="col-md-6"
        *ngIf="commonData.avgTrafficWaitByWeekOfMonthVisible == true"
      >
        <kendo-chart
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{
              '_Report_Lobby_Traffic_and_WaitTime_WeekMonth_Text_' | translate
            }}"
          ></kendo-chart-title>
          <kendo-chart-legend position="bottom">
            <kendo-chart-legend-item
              [visual]="legendVisuals"
            ></kendo-chart-legend-item>
          </kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="
                let item of commonData.avgTrafficWaitByWeekOfMonthValueAxis
              "
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
              [labels]="item.labels ?? {}"
            >
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [categories]="commonData.avgTrafficWaitByWeekOfMonthCategories"
              [axisCrossingValue]="
                commonData.avgTrafficWaitByWeekOfMonthCrossingValues
              "
            >
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              *ngIf="isACLicenseEnabled$ | async"
              [data]="commonData.avgTrafficWaitByWeekOfMonthSeriesData[0].data"
              [name]="commonData.avgTrafficWaitByWeekOfMonthSeriesData[0].name"
              [color]="
                commonData.avgTrafficWaitByWeekOfMonthSeriesData[0].color
              "
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_General_Appointments_Text_' | translate }}: {0:N1}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByWeekOfMonthSeriesData[1].data"
              [name]="commonData.avgTrafficWaitByWeekOfMonthSeriesData[1].name"
              [color]="
                commonData.avgTrafficWaitByWeekOfMonthSeriesData[1].color
              "
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_Report_WalkIns_Ts_Text_' | translate }}: {0:N1}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByWeekOfMonthSeriesData[2].data"
              [name]="commonData.avgTrafficWaitByWeekOfMonthSeriesData[2].name"
              [color]="
                commonData.avgTrafficWaitByWeekOfMonthSeriesData[2].color
              "
              stack="true"
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_General_LWA_Text_' | translate }}: {0:N1}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.avgTrafficWaitByWeekOfMonthSeriesData[3].data"
              [name]="commonData.avgTrafficWaitByWeekOfMonthSeriesData[3].name"
              [color]="
                commonData.avgTrafficWaitByWeekOfMonthSeriesData[3].color
              "
              [type]="commonData.avgTrafficWaitByWeekOfMonthSeriesData[3].type"
              [axis]="commonData.avgTrafficWaitByWeekOfMonthSeriesData[3].axis"
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_General_Report_Wait_Time_Text_" | translate }}:
                    {{ dataItem.ValMinutes }}:{{ dataItem.ValSeconds }}
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
    </div>
    <!-- Products and Services View Charts -->
    <div
      class="row report-charts"
      *ngIf="
        pageInitialized == true &&
        getCurrentViewName() === 'Products & Services'
      "
    >
      <div
        class="col-md-12"
        *ngIf="commonData.productsAndServicesProvidedVisible == true"
      >
        <!-- Products & Services -->
        <kendo-chart
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{ '_Report_Lobby_PS_Provided_Text_' | translate }}"
          ></kendo-chart-title>
          <kendo-chart-legend position="bottom">
            <kendo-chart-legend-item
              [visual]="legendVisuals"
            ></kendo-chart-legend-item>
          </kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="
                let item of commonData.productsAndServicesProvidedValueAxis
              "
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
            >
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [min]="commonData.firstCategoryIndex"
              [max]="commonData.lastCategoryIndex"
              [categories]="commonData.productsAndServicesProvidedCategories"
              [labels]="categoryLabelMultiline"
            >
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              [data]="commonData.productsAndServicesProvidedSeriesData[0].data"
              [name]="commonData.productsAndServicesProvidedSeriesData[0].name"
              [color]="
                commonData.productsAndServicesProvidedSeriesData[0].color
              "
              [stack]="
                commonData.productsAndServicesProvidedSeriesData[0].stack
              "
            >
              <kendo-chart-series-item-tooltip
                format="{{
                  '_Report_Lobby_Products_Text_' | translate
                }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.productsAndServicesProvidedSeriesData[1].data"
              [name]="commonData.productsAndServicesProvidedSeriesData[1].name"
              [color]="
                commonData.productsAndServicesProvidedSeriesData[1].color
              "
              [stack]="
                commonData.productsAndServicesProvidedSeriesData[1].stack
              "
            >
              <kendo-chart-series-item-tooltip
                format="{{
                  '_Report_Lobby_Services_Text_' | translate
                }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="commonData.productsAndServicesProvidedSeriesData[2].data"
              [name]="commonData.productsAndServicesProvidedSeriesData[2].name"
              [color]="
                commonData.productsAndServicesProvidedSeriesData[2].color
              "
              [stack]="
                commonData.productsAndServicesProvidedSeriesData[2].stack
              "
            >
              <kendo-chart-series-item-tooltip
                format="{{ '_Report_Filters_Other_Text_' | translate }}: {0:N0}"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
      <div
        class="col-md-12"
        *ngIf="commonData.avgAssistTimeByProductOrServiceVisible == true"
      >
        <kendo-chart
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{
              '_Report_Lobby_Average_Assist_Time_by_PS_Text_' | translate
            }}"
          ></kendo-chart-title>
          <kendo-chart-legend position="bottom">
            <kendo-chart-legend-item
              [visual]="legendVisuals"
            ></kendo-chart-legend-item>
          </kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="
                let item of commonData.avgAssistTimeByProductOrServiceValueAxis
              "
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
            >
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [min]="commonData.firstCategoryIndex"
              [max]="commonData.lastCategoryIndex"
              [categories]="
                commonData.avgAssistTimeByProductOrServiceCategories
              "
              [labels]="categoryLabelMultiline"
            >
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              [data]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[0].data
              "
              [name]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[0].name
              "
              [color]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[0].color
              "
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_Report_Lobby_Products_Text_" | translate }}:
                    {{ dataItem.ValMinutes }}:{{ dataItem.ValSeconds }}
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[1].data
              "
              [name]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[1].name
              "
              [color]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[1].color
              "
            >
              <kendo-chart-series-item-tooltip
                format="{{
                  '_General_Time_Standard_Text_' | translate
                }}: {0:N0}:00"
              ></kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[2].data
              "
              [name]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[2].name
              "
              [color]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[2].color
              "
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_Report_Lobby_Services_Text_" | translate }}:
                    {{ dataItem.ValMinutes }}:{{ dataItem.ValSeconds }}
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[3].data
              "
              [name]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[3].name
              "
              [color]="
                commonData.avgAssistTimeByProductOrServiceSeriesData[3].color
              "
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ '_Report_Filters_Other_Text_' | translate }}:
                    {{ dataItem.ValMinutes }}:{{ dataItem.ValSeconds }}
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
    </div>
    <!-- Employee View Charts -->
    <div
      class="row report-charts"
      *ngIf="pageInitialized == true && getCurrentViewName() === 'Employee'"
    >
      <div
        class="col-md-12"
        *ngIf="commonData.productsAndServicesByEmployeeVisible == true"
      >
        <kendo-chart
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{
              '_Report_Lobby_PS_Provided_by_Employee_Text_' | translate
            }}"
          ></kendo-chart-title>
          <kendo-chart-legend position="bottom">
            <kendo-chart-legend-item
              [visual]="legendVisuals"
            ></kendo-chart-legend-item>
          </kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="
                let item of commonData.productsAndServicesByEmployeeValueAxis
              "
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
            >
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [min]="commonData.firstCategoryIndex"
              [max]="commonData.lastCategoryIndex"
              [categories]="commonData.productsAndServicesByEmployeeCategories"
            >
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              [data]="
                commonData.productsAndServicesByEmployeeSeriesData[0].data
              "
              [name]="
                commonData.productsAndServicesByEmployeeSeriesData[0].name
              "
              [color]="
                commonData.productsAndServicesByEmployeeSeriesData[0].color
              "
              [stack]="
                commonData.productsAndServicesByEmployeeSeriesData[0].stack
              "
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  {{ dataItem.tooltip }}
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="
                commonData.productsAndServicesByEmployeeSeriesData[1].data
              "
              [name]="
                commonData.productsAndServicesByEmployeeSeriesData[1].name
              "
              [color]="
                commonData.productsAndServicesByEmployeeSeriesData[1].color
              "
              [stack]="
                commonData.productsAndServicesByEmployeeSeriesData[1].stack
              "
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  {{ dataItem.tooltip }}
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              [data]="
                commonData.productsAndServicesByEmployeeSeriesData[2].data
              "
              [name]="
                commonData.productsAndServicesByEmployeeSeriesData[2].name
              "
              [color]="
                commonData.productsAndServicesByEmployeeSeriesData[2].color
              "
              [stack]="
                commonData.productsAndServicesByEmployeeSeriesData[2].stack
              "
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  {{ dataItem.tooltip }}
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
            <kendo-chart-series-item
              *ngIf="commonData.productsAndServicesByEmployeeSeriesData.length > 3"
              [data]="
                commonData.productsAndServicesByEmployeeSeriesData[3].data
              "
              [name]="
                commonData.productsAndServicesByEmployeeSeriesData[3].name
              "
              [color]="
                commonData.productsAndServicesByEmployeeSeriesData[3].color
              "
              [stack]="
                commonData.productsAndServicesByEmployeeSeriesData[3].stack
              "
              [visibleInLegend]="false"
            >
              <kendo-chart-series-item-labels
                [visible]="true"
                position="outsideEnd"
                [content]="setTotal"
                [visual]="setTotalVisual"
              ></kendo-chart-series-item-labels>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
      <div
        class="col-md-12"
        *ngIf="commonData.avgAssistTimeByEmployeeVisible == true"
      >
        <kendo-chart
          (seriesHover)="seriesHover($event)"
          [pannable]="{ lock: 'y' }"
          [zoomable]="{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }"
        >
          <kendo-chart-title
            text="{{
              '_Report_Lobby_AssistTime_by_Employee_Text_' | translate
            }}"
          ></kendo-chart-title>
          <kendo-chart-legend position="bottom">
            <kendo-chart-legend-item
              [visual]="legendVisuals_AssistTime"
            ></kendo-chart-legend-item>
          </kendo-chart-legend>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item
              *ngFor="let item of commonData.avgAssistTimeByEmployeeValueAxis"
              [name]="item.name ?? ''"
              [title]="{ text: item.title }"
              [min]="item.min"
              [max]="item.max"
              [majorUnit]="item.majorUnit ?? 0"
              [color]="item.color ?? ''"
            >
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item
              [min]="commonData.firstCategoryIndex"
              [max]="commonData.lastCategoryIndex"
              [categories]="commonData.avgAssistTimeByEmployeeCategories"
            >
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-series>
            <kendo-chart-series-item
              *ngFor="let item of commonData.mappedEmployeeAssistSeries"
              [data]="item.items"
              field="avgAssistTime"
              [name]="item.value"
              type="column"
              [visual]="seriesVisuals"
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_General_Average_Assist_Time_Text_" | translate }}:
                    {{ dataItem.ValMinutes }}:{{ dataItem.ValSeconds }}
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>

            <!-- [markers]="{visual: visual}"  -->
            <kendo-chart-series-item
              *ngFor="let item of commonData.mappedEmployeeAssistSeries"
              [data]="item.items"
              field="StdMinutes"
              type="line"
              [width]="1"
              [highlight]="{ visible: false }"
              [color]="getSeriesColorBasedOnProductServiceType(item.items[0])"
            >
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-dataItem="dataItem">
                  <div style="text-align: center">
                    {{ "_General_Time_Standard_Text_" | translate }}:
                    {{ dataItem.StdMinutes }}:00
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
    </div>
    <!-- Details View -->
    <div
      *ngIf="
        pageInitialized == true &&
        getCurrentViewName() === 'Details' &&
        isLocationDataAvailable
      "
    >
      <div
        class="d-flex align-items-center justify-content-end mt-3 mb-3 btn-panel-right"
      >
        <div
          class="cc-search"
          *ngIf="loadSeachWithGrid && getCurrentViewName() === 'Details'"
        >
          <input
            [(ngModel)]="filterText"
            class="form-control"
            (keydown.enter)="onFilterTextEnterKeyPress($event)"
            placeholder="{{ '_General_Search_Text_' | translate }}"
            required
          />
          <button
            [ngClass]="{ 'show-btn': showClearButton }"
            (click)="onClearSearchTextClicked()"
            class="cc-close-btn"
          >
            <span class="fas fa-times"></span>
          </button>
          <button (click)="onFilterTextSearchClicked()" class="cc-search-btn">
            <span class="fas fa-search"></span>
          </button>
        </div>
        <button
          type="button"
          class="btn btn-primary"
          icon="file-csv"
          (click)="exportToCsv()"
        >
          {{ "_Report_Lobby_Export_Text_" | translate }}
        </button>
      </div>
      <kendo-grid
        #grid="kendoGrid"
        [data]="gridData"
        [pageSize]="pageSize"
        [skip]="skip"
        [sort]="sort"
        [sortable]="{ allowUnsort: false, mode: 'single' }"
        scrollable="none"
        (dataStateChange)="dataStateChange($event)"
        [selectable]="true"
        [pageable]="{ pageSizes: [10, 20, 30, 50, 100] }"
        (pageChange)="pageChange($event)"
        (sortChange)="sortChange($event)"
        (excelExport)="onExcelExport($event)"
      >
        <kendo-grid-messages
          pagerItemsPerPage="{{ '_Items_Per_Page_Text_' | translate }}"
          pagerFirstPage="{{ '_Go_To_First_Page_Text_' | translate }}"
          pagerLastPage="{{ '_Go_To_Last_Page_Text_' | translate }}"
          pagerNextPage="{{ '_Go_To_Next_Page_Text_' | translate }}"
          pagerPreviousPage="{{ '_Go_To_Previous_Page_Text_' | translate }}"
          detailExpand="{{ '_General_Expand_Details_Text_' | translate }}"
          detailCollapse="{{ '_General_Collapse_Details_Text_' | translate }}"
          pagerPage="{{ '_Page_Grid_Text_' | translate }}"
          noRecords="{{ '_NoRecords_Grid_Text_' | translate }}"
          pagerItems="{{
            '_General_Kendo_Grid_Pageable_Items_Text_' | translate
          }}"
          pagerOf="{{ '_General_Kendo_Grid_Pageable_Of_Text_' | translate }}"
        ></kendo-grid-messages>
        <!-- <kendo-grid-column
          title="{{ '_Lobby_Wrap_Up_Lobby_ID_Text_' | translate }}"
          field="lobbyEntryId"
          [width]="50"
        ></kendo-grid-column>
        <kendo-grid-column
          field="type"
          title="{{ '_Report_Details_Visitor_Type_Text_' | translate }}"
          [width]="7"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="d-flex align-items-center">
              <div class="lobby-grid-icon-area">
                <button
                  *ngIf="dataItem.type == 'Walk-In'"
                  class="cc-icon-btn cursor"
                  title="{{ '_General_Report_WalkIn_Text_' | translate }}"
                >
                  <span class="fas fa-walking walk-in-icon"></span>
                </button>
                <button
                  *ngIf="dataItem.type == 'Appointment'"
                  class="cc-icon-btn cursor"
                  title="{{ '_General_Report_Appointment_Text_' | translate }}"
                >
                  <img
                    class="in-person-appointment-icon"
                    src="assets/images/icon/in-person-appointment.svg"
                  />
                </button>
              </div>
            </div>
          </ng-template>
        </kendo-grid-column> -->
        <kendo-grid-column
          title="{{ '_General_Report_CheckinTime_Text_' | translate }}"
          field="addedTime"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Location_Text_' | translate }}"
          field="location"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Account_Number_Field_Text_' | translate }}"
          field="accountNumber"
          *ngIf="this.commonData.lobbyConfiguration.enableAccountNumber"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_AccountName_Text_' | translate }}"
          field="accountName"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Confirmation_Text_' | translate }} #"
          field="confirmationNumber"
          *ngIf="isACLicenseEnabled$ | async"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Requested_Items_Text_' | translate }}"
          field="requestedService"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Requested_Staff_Text_' | translate }}"
          field="userRequested"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_MainAssisted_Staff_Text_' | translate }}"
          field="mainAssistedBy"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Wait_Time_Text_' | translate }}"
          field="waitTime"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Assist_Time_Text_' | translate }}"
          field="serviceTime"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_WrapUpTime_Text_' | translate }}"
          field="wrapUpTime"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Interaction_Time_Text_' | translate }}"
          field="interactionTime"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_AutoWrapUp_Text_' | translate }}"
          field="autoWrapUp"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Status_Text_' | translate }}"
          field="status"
        >
          <ng-template kendoGridCellTemplate let-dataItem>{{
            dataItem.status === "Completed"
              ? ("_General_Completed_Text_" | translate)
              : dataItem.status === "No Show"
                ? ("_General_No_Show_Text_" | translate)
                : ("_General_LWA_Abbr_Text_" | translate)
          }}</ng-template>
        </kendo-grid-column>
        <!-- <kendo-grid-column
          title="{{ '_General_Report_Comments_Text_' | translate }}"
          field="comments"
          [sortable]="false"
        ></kendo-grid-column> -->
        <ng-template kendoGridDetailTemplate let-dataItem>
          <kendo-grid [data]="dataItem.servicesProvided" scrollable="none">
            <kendo-grid-messages
              pagerFirstPage="{{ '_Go_To_First_Page_Text_' | translate }}"
              pagerLastPage="{{ '_Go_To_Last_Page_Text_' | translate }}"
              pagerNextPage="{{ '_Go_To_Next_Page_Text_' | translate }}"
              pagerPreviousPage="{{ '_Go_To_Previous_Page_Text_' | translate }}"
              pagerPage="{{ '_Page_Grid_Text_' | translate }}"
              noRecords="{{ '_NoRecords_Grid_Text_' | translate }}"
              pagerItems="{{
                '_General_Kendo_Grid_Pageable_Items_Text_' | translate
              }}"
              pagerOf="{{
                '_General_Kendo_Grid_Pageable_Of_Text_' | translate
              }}"
            ></kendo-grid-messages>

            <kendo-grid-column
              title="{{ '_General_Report_Product/Service_Text_' | translate }}"
              field="serviceName"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Category_Text_' | translate }}"
              field="category.productCategoryName"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_Requested_Text_' | translate }}"
              field="requested"
              [width]="90"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_ReferenceNumber_Text_' | translate }}"
              field="referenceNumber"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_AssistedBy_Text_' | translate }}"
              field="assistedBy"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_Wait_Time_Text_' | translate }}"
              field="waitTime"
              [width]="130"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_Assist_Time_Text_' | translate }}"
              field="serviceTime"
              [width]="130"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_WrapUpTime_Text_' | translate }}"
              field="wrapUpTime"
              [width]="130"
            ></kendo-grid-column>
            <kendo-grid-column
              title="{{ '_General_Report_Interaction_Time_Text_' | translate }}"
              field="interactionTime"
              [width]="130"
            ></kendo-grid-column>
          </kendo-grid>
        </ng-template>
        <kendo-grid-excel
          fileName="LobbyDetailViewExport.xlsx"
          [fetchData]="allData"
        >
          <kendo-excelexport-column
            title="{{ '_General_Report_Id_Text_' | translate }}"
            field="lobbyEntryId"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Type_Text_' | translate }}"
            field="type"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_CheckinTime_Text_' | translate }}"
            field="addedTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Assisted_Time_Text_' | translate }}"
            field="assistedTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Completed_Time_Text_' | translate }}"
            field="completedTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Location_Text_' | translate }}"
            field="location"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_Account_Number_Field_Text_' | translate }}"
            field="accountNumber"
            *ngIf="commonData.lobbyConfiguration.enableAccountNumber"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_AccountName_Text_' | translate }}"
            field="accountName"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{
              '_General_Report_Confirmation_Number_Text_' | translate
            }}"
            field="confirmationNumber"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Requested_Staff_Text_' | translate }}"
            field="userRequested"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_AutoWrapUp_Text_' | translate }}"
            field="autoWrapUp"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Status_Text_' | translate }}"
            field="status"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Comments_Text_' | translate }}"
            field="comments"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Product/Service_Text_' | translate }}"
            field="serviceName"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_ReferenceNumber_Text_' | translate }}"
            field="serviceName"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_AssistedBy_Text_' | translate }}"
            field="assistedBy"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Wait_Time_Text_' | translate }}"
            field="waitTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Assisted_Time_Text_' | translate }}"
            field="serviceTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_WrapUpTime_Text_' | translate }}"
            field="wrapUpTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_Report_Lobby_TotalTime_Text_' | translate }}"
            field="interactionTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_lwaReason_Text_' | translate }}"
            field="lwaReason"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_closedBy_Text_' | translate }}"
            field="closedByUser"
          ></kendo-excelexport-column>
        </kendo-grid-excel>
      </kendo-grid>
    </div>
    <!-- Sign In Out Report -->
    <div
      *ngIf="
        pageInitialized == true &&
        getCurrentViewName() === 'Staff Sign In/Out' &&
        hasViewSignInOutReportPermission
      "
    >
      <div class="d-flex align-items-center justify-content-end mt-3 mb-2">
        <button
          type="button"
          class="btn btn-primary"
          icon="file-csv"
          (click)="signInOutExportToCsv()"
        >
          {{ "_Report_Lobby_Export_Text_" | translate }}
        </button>
      </div>
      <kendo-grid
        #grid="kendoGrid"
        class="sign-in-out-grid"
        [kendoGridBinding]="signInOutDetailGridDataView"
        [pageSize]="pageSize"
        [skip]="skip"
        scrollable="none"
        (dataStateChange)="onDataStateChange($event)"
        [groupable]="{ showFooter: true, enabled: false }"
        [group]="group"
        [pageable]="{ pageSizes: [2, 10, 20, 30, 50, 100] }"
        (excelExport)="onExcelExport($event)"
      >
        <kendo-grid-messages
          pagerItemsPerPage="{{ '_Items_Per_Page_Text_' | translate }}"
          pagerFirstPage="{{ '_Go_To_First_Page_Text_' | translate }}"
          pagerLastPage="{{ '_Go_To_Last_Page_Text_' | translate }}"
          pagerNextPage="{{ '_Go_To_Next_Page_Text_' | translate }}"
          pagerPreviousPage="{{ '_Go_To_Previous_Page_Text_' | translate }}"
          pagerPage="{{ '_Page_Grid_Text_' | translate }}"
          noRecords="{{ '_NoRecords_Grid_Text_' | translate }}"
          pagerItems="{{
            '_General_Kendo_Grid_Pageable_Items_Text_' | translate
          }}"
          pagerOf="{{ '_General_Kendo_Grid_Pageable_Of_Text_' | translate }}"
        ></kendo-grid-messages>

        <kendo-grid-column
          title="{{ '_Report_SignInOut_Location_Text_' | translate }}"
          field="locationName"
        >
          <ng-template
            kendoGridGroupHeaderTemplate
            let-group="group"
            let-value="value"
          >
            <label class="interaction-title"
              >{{ "_Report_SignInOut_Location_Text_" | translate }}:
              {{ group.items[0]?.locationNameWithTimeZone }}</label
            >
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Report_SignInOut_UserName_Text_' | translate }}"
          field="employeeName"
        >
          <ng-template kendoGridGroupFooterTemplate>
            <span>{{ "_Report_SignInOut_Summary_Text_" | translate }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Report_SignInOut_SignInDate_Text_' | translate }}"
          field="staffSignInDate"
          [width]="100"
        >
          <ng-template kendoGridGroupFooterTemplate let-group="group">
            <span>{{ getDistinctCount("staffSignInDate", group.items) }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Report_SignInOut_SignInTime_Text_' | translate }}"
          field="staffSignInTime"
          [width]="100"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Report_SignInOut_SignInTime_Text_' | translate }}"
          field="signedInTimeInSeconds"
          [hidden]="true"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Report_SignInOut_SignOutTime_Text_' | translate }}"
          field="staffSignOutTime"
          [width]="100"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Report_SignInOut_SignOutReason_Text_' | translate }}"
          field="signOutReason"
          [sortable]="false"
        >
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="cc-break-word" [title]="dataItem.signOutReason">
              {{ dataItem.signOutReason }}
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Assist_Time_Text_' | translate }}"
          field="interactionTimeInSeconds"
          [hidden]="true"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_General_Report_Assist_Time_Text_' | translate }}"
          field="interactionTime"
          [width]="50"
        >
          <ng-template
            kendoGridGroupFooterTemplate
            let-group
            let-aggregates="aggregates"
          >
            <span>{{
              formatIdleTime(aggregates.interactionTimeInSeconds.sum)
            }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Report_SignInOut_IdleTime_Text_' | translate }}"
          field="idleTimeInSeconds"
          [hidden]="true"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Report_SignInOut_IdleTime_Text_' | translate }}"
          field="idleTime"
          [width]="50"
        >
          <ng-template
            kendoGridGroupFooterTemplate
            let-group
            let-aggregates="aggregates"
          >
            <span>{{ formatIdleTime(aggregates.idleTimeInSeconds.sum) }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Report_SignInOut_SignedOutTime_Text_' | translate }}"
          field="signedOutTimeInSeconds"
          [hidden]="true"
        ></kendo-grid-column>
        <kendo-grid-column
          title="{{ '_Report_SignInOut_SignedOutTime_Text_' | translate }}"
          field="signedOutTime"
          [width]="50"
        >
          <ng-template
            kendoGridGroupFooterTemplate
            let-group
            let-aggregates="aggregates"
          >
            <span>{{
              formatIdleTime(aggregates.signedOutTimeInSeconds.sum)
            }}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column
          title="{{
            '_Report_SignInOut_ProductivePercentage_Text_' | translate
          }}"
          field="productivityPercentageStr"
          [width]="50"
        >
          <ng-template
            kendoGridGroupFooterTemplate
            let-group
            let-aggregates="aggregates"
          >
            <span>{{
              calculatePercentage(
                aggregates.interactionTimeInSeconds.sum,
                aggregates.signedInTimeInSeconds.sum
              )
            }}</span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-excel
          fileName="signInOutExcelExport.xlsx"
          [fetchData]="allData"
        >
          <kendo-excelexport-column
            title="{{ '_Report_SignInOut_Location_Text_' | translate }}"
            field="locationNameWithTimeZone"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_Report_SignInOut_UserName_Text_' | translate }}"
            field="employeeName"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_Report_SignInOut_SignInDate_Text_' | translate }}"
            field="staffSignInDate"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_Report_SignInOut_SignInTime_Text_' | translate }}"
            field="staffSignInTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_Report_SignInOut_SignOutTime_Text_' | translate }}"
            field="staffSignOutTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_Report_SignInOut_SignOutReason_Text_' | translate }}"
            field="signOutReason"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_General_Report_Assist_Time_Text_' | translate }}"
            field="interactionTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_Report_SignInOut_IdleTime_Text_' | translate }}"
            field="idleTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{ '_Report_SignInOut_SignedOutTime_Text_' | translate }}"
            field="signedOutTime"
          ></kendo-excelexport-column>
          <kendo-excelexport-column
            title="{{
              '_Report_SignInOut_ProductivePercentage_Text_' | translate
            }}"
            field="productivityPercentageStr"
          ></kendo-excelexport-column>
        </kendo-grid-excel>
      </kendo-grid>
    </div>
  </div>
</div>
